var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocofast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23198 4.00598C1.82353 4.41444 1.82353 5.07667 2.23198 5.48513L6.22568 9.47882L7.70482 7.99967L3.71113 4.00598C3.30267 3.59753 2.64044 3.59753 2.23198 4.00598Z",
    fill: "#0067E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64032 6.96427C1.23187 7.37273 1.23187 8.03496 1.64033 8.44342L4.4507 11.2538L5.92985 9.77465L3.11947 6.96427C2.71102 6.55582 2.04878 6.55582 1.64032 6.96427Z",
    fill: "#0067E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9943 2.23101C11.5859 1.82255 10.9237 1.82255 10.5152 2.23101L6.5215 6.2247L8.00065 7.70384L11.9943 3.71015C12.4028 3.3017 12.4028 2.63946 11.9943 2.23101Z",
    fill: "#0067E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03605 1.63935C8.6276 1.23089 7.96536 1.23089 7.55691 1.63935L4.74653 4.44973L6.22568 5.92887L9.03605 3.11849C9.44451 2.71004 9.44451 2.0478 9.03605 1.63935Z",
    fill: "#0067E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7693 11.9934C14.1778 11.5849 14.1778 10.9227 13.7693 10.5142L9.77562 6.52053L8.29648 7.99967L12.2902 11.9934C12.6986 12.4018 13.3609 12.4018 13.7693 11.9934Z",
    fill: "#0067E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.361 9.03508C14.7694 8.62662 14.7694 7.96438 14.361 7.55593L11.5506 4.74555L10.0715 6.2247L12.8818 9.03508C13.2903 9.44353 13.9525 9.44353 14.361 9.03508Z",
    fill: "#0067E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00696 13.7683C4.41541 14.1768 5.07765 14.1768 5.4861 13.7683L9.4798 9.77465L8.00065 8.2955L4.00696 12.2892C3.5985 12.6976 3.5985 13.3599 4.00696 13.7683Z",
    fill: "#0067E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96525 14.36C7.3737 14.7685 8.03594 14.7685 8.44439 14.36L11.2548 11.5496L9.77563 10.0705L6.96525 12.8809C6.55679 13.2893 6.55679 13.9515 6.96525 14.36Z",
    fill: "#0067E2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocofast);
export default __webpack_public_path__ + "static/media/Locofast.cae58bb8dbc8c9b53eec21956a8a1665.svg";
export { ForwardRef as ReactComponent };